<div class="listing">
  <div class="listing_header">
    {{"multiAuction.Items"|translate}}
    <button mat-button (click)="OnClickSort()"
      *ngIf="_config.getAuthUserInfo()?.user?.role_code=='Admin'&& roomDetails?.type=='upcoming'" [appLoading]="loading"
      class="btnLight_fill">{{(!disAllowSort?"Auctions.save":"sort.Sort")|translate}}</button>
  </div>
  <ng-container *ngIf="loadingData">
    <app-loading></app-loading>
  </ng-container>
  <ng-container *ngIf="!loadingData">
    <div class="list" *ngIf="listing?.length">

      <!-- <div class="controles group_btn p-2 m-0 border-bottom-md"
        >
        <button mat-button (click)="OnClickSort()" [appLoading]="loading"
          class="btnLight_fill">{{(!disAllowSort?"Auctions.save":"sort.Sort")|translate}}</button>
      </div> -->
      <div class="w-100" style="height: 100%;overflow-y: auto;overflow-x: hidden;" (scrolled)="getNextPage()"
        [infiniteScrollDistance]="2" [infiniteScrollThrottle]="pageCount" [scrollWindow]="false" infiniteScroll
        cdkDropList (cdkDropListDropped)="drop($event)">

        <div *ngFor="let item of listing; index as x" class="listing_item row flex-nowrap"
          [ngClass]="{'closed': item?.is_closed,'selected':CurrentItemId == item?.id,'active':activeAuctionWork == item?.id && !item?.is_closed && roomDetails?.type=='ongoing'}"
          (click)="getItems(item.id)" [cdkDragData]="item" [cdkDragDisabled]="disAllowSort" cdkDrag>
          <div class="img col-auto">
            <img [src]="item?.main_image" onerror="this.src='assets/images/default-img.png'" alt="">
          </div>
          <div class="detailes col-8 col-sm-10 col-lg-8">
            <ng-container>
              <p class="status_upcoming"
                *ngIf="(activeAuctionWork != item?.id && !item.is_closed)||(activeAuctionWork == item?.id && roomDetails?.type=='upcoming')">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
                  <circle id="circle" cx="3" cy="3" r="3" />
                </svg>
                {{"Main Auction.upcoming"|translate}}
              </p>
              <p class="status_ongoing"
                *ngIf="activeAuctionWork == item?.id && !item?.is_closed && roomDetails?.type=='ongoing'">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
                  <circle id="circle" cx="3" cy="3" r="3" />
                </svg>
                {{"Main Auction.ongoing"|translate}}
              </p>
            </ng-container>


            <div class="name"> {{item?.name}}</div>
            <div class="start-biding">
              <p>{{"Main Auction.Starting bid"|translate}}</p>
              <div>
                {{item?.minimum_price}}
                <span>{{"Main Auction.SR"|translate}}</span>
              </div>
            </div>
          </div>
        </div>
        <app-loading *ngIf="loadMoreData"></app-loading>
      </div>

    </div>
    <div class="no-data py-4" *ngIf="!listing.length">
      <img src="assets/images/Auctions_no_data.svg" alt="">
      <p>{{'items-requests.No items added yet' | translate}}</p>
    </div>
  </ng-container>


</div>